import { formatImgSrc } from './formatImgSrc';

export function formatLimitBackgroundImageStyle(style = {}, { imgWidth, imgHeight, imgUrl } = {}) {
    return Object.assign(style, {
        backgroundImage: `url(${formatImgSrc({
            imgWidth,
            imgHeight,
            imgUrl,
        })})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: `${((imgHeight * 100) / imgWidth).toFixed(2)}vw`,
    });
}
